var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wl-com"},[_c('com-box-1'),_c('com-box-2'),_c('com-box-3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }